/**
 * Display-only role label — strips the "tenant" prefix product-wide so the
 * UI reads "Owner" / "Admin" / "User" instead of "Tenant Owner" etc.
 * Purely cosmetic: role keys ('tenant_owner', 'tenant_admin', ...) and the
 * seeded Role.name values in the database are unchanged — only what's
 * rendered on screen goes through this.
 */
export function roleLabel(raw?: string | null): string {
  if (!raw) return '';
  const words = raw
    .replace(/_/g, ' ')
    .split(' ')
    .filter((w) => w.length > 0 && w.toLowerCase() !== 'tenant');
  if (words.length === 0) return '';
  return words.map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ');
}
